import { Box, DialogActions, DialogContent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { buildCompactInputSx } from '@/shared/ui/form-fields/fieldStyles';

export const StyledDialogContent = styled(DialogContent)(() => ({
  paddingTop: 0,
  paddingLeft: 0,
  paddingRight: 0,
  paddingBottom: '1.5rem',
  overflow: 'hidden',
}));

export const LoadingText = styled(Typography)(() => ({
  paddingLeft: '1rem',
  paddingRight: '1rem',
  paddingTop: '0.75rem',
}));

export const ErrorText = styled(Typography)(() => ({
  paddingLeft: '1rem',
  paddingRight: '1rem',
  paddingTop: '0.75rem',
}));

export const ContentStack = styled('div')(() => ({
  marginTop: '0.25rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
}));

export const HeaderGrid = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 74px',
  gap: '1rem',
  alignItems: 'end',
  paddingBottom: '0.5rem',
  paddingRight: '1.25rem',
}));

export const HeaderLabel = styled(Typography)(({ theme }) => ({
  fontStyle: 'normal',
  fontWeight: 500,
  color: theme.palette.text.secondary,
}));

export const RowsStack = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  maxHeight: '55vh',
  overflowY: 'auto',
  paddingRight: '1.25rem',
}));

export const RowGrid = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 74px',
  gap: '1rem',
  alignItems: 'center',
}));

export const TextFieldSx = buildCompactInputSx(false, { paddingBottom: 0 });

export const StyledDialogActions = styled(DialogActions)(() => ({
  paddingLeft: 0,
  paddingRight: 0,
  paddingBottom: '1rem',
  paddingTop: '0.5rem',
  gap: '0.5rem',
  '& > :not(style) ~ :not(style)': {
    marginLeft: 0,
  },
}));
